export enum AnalyticCacheOptions {
	Off = 'Off',
	Refresh = 'Refresh',
	Try = 'Try',
	Normal = 'Normal'
}
